export const BASE_API_URL = "https://3pv.buildonlinestaging.com/api";
